import { Smartphone, CheckCircle2, Copy, RefreshCw, Layers, ShieldCheck, ArrowRightLeft, Radio, Database, Globe, ShoppingCart, KeyRound } from "lucide-react";

export function SyncOverview({ status, loading, loadStatus }) {
  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
            <Smartphone className="text-emerald-600" /> App & Website Live Sync Hub
          </h1>
          <p className="text-slate-500 text-sm mt-0.5">
            Single Source of Truth: Android App + Customer Website + POS + Admin share ONE central FastAPI + MongoDB backend.
          </p>
        </div>
        <button
          data-testid="refresh-sync-status"
          onClick={loadStatus}
          disabled={loading}
          className="px-4 py-2 bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 rounded-lg font-semibold text-sm flex items-center gap-2 self-start"
        >
          <RefreshCw size={15} className={loading ? "animate-spin" : ""} /> Refresh Status
        </button>
      </div>

      {/* Architecture diagram card */}
      <div className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 rounded-2xl p-6 text-white shadow-lg border border-slate-700">
        <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <Database className="text-emerald-400" size={20} />
            <span className="font-bold text-base text-emerald-400">ONE CENTRAL BACKEND (FastAPI + MongoDB)</span>
          </div>
          <span className="bg-emerald-500/20 text-emerald-300 text-xs font-bold px-3 py-1 rounded-full border border-emerald-500/30 flex items-center gap-1.5">
            <Radio size={12} className="text-emerald-400 animate-pulse" /> LIVE SYNC ACTIVE
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          <div className="bg-white/10 backdrop-blur rounded-xl p-4 border border-white/10 text-center">
            <Smartphone className="mx-auto text-emerald-400 mb-2" size={28} />
            <p className="font-bold text-sm">Android App</p>
            <p className="text-[11px] text-slate-300 mt-1">Rani Super Market</p>
            <span className="inline-block mt-2 bg-emerald-500/20 text-emerald-300 text-[10px] font-bold px-2 py-0.5 rounded">
              Ready to point
            </span>
          </div>

          <div className="bg-white/10 backdrop-blur rounded-xl p-4 border border-white/10 text-center">
            <Globe className="mx-auto text-sky-400 mb-2" size={28} />
            <p className="font-bold text-sm">Customer Website</p>
            <p className="text-[11px] text-slate-300 mt-1">Responsive Web App</p>
            <span className="inline-block mt-2 bg-emerald-500/20 text-emerald-300 text-[10px] font-bold px-2 py-0.5 rounded">
              Connected Live
            </span>
          </div>

          <div className="bg-white/10 backdrop-blur rounded-xl p-4 border border-white/10 text-center">
            <ShoppingCart className="mx-auto text-purple-400 mb-2" size={28} />
            <p className="font-bold text-sm">Galla POS</p>
            <p className="text-[11px] text-slate-300 mt-1">Store Cashier Terminal</p>
            <span className="inline-block mt-2 bg-emerald-500/20 text-emerald-300 text-[10px] font-bold px-2 py-0.5 rounded">
              Connected Live
            </span>
          </div>

          <div className="bg-white/10 backdrop-blur rounded-xl p-4 border border-white/10 text-center">
            <Layers className="mx-auto text-orange-400 mb-2" size={28} />
            <p className="font-bold text-sm">Owner Admin</p>
            <p className="text-[11px] text-slate-300 mt-1">Master Control Panel</p>
            <span className="inline-block mt-2 bg-emerald-500/20 text-emerald-300 text-[10px] font-bold px-2 py-0.5 rounded">
              Connected Live
            </span>
          </div>
        </div>
      </div>

      {/* Sync stats & guarantees */}
      {status && (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div className="bg-white rounded-xl border border-slate-200 p-4">
            <p className="text-xs font-semibold text-slate-500 uppercase">Synced Products</p>
            <p className="text-2xl font-extrabold text-slate-900 mt-1">{status.metrics?.active_products}</p>
            <p className="text-[11px] text-emerald-600 font-semibold mt-0.5">Same catalog for App & Web</p>
          </div>
          <div className="bg-white rounded-xl border border-slate-200 p-4">
            <p className="text-xs font-semibold text-slate-500 uppercase">Total Live Stock</p>
            <p className="text-2xl font-extrabold text-slate-900 mt-1">{status.metrics?.total_stock_units} units</p>
            <p className="text-[11px] text-emerald-600 font-semibold mt-0.5">Atomic deduction on checkout</p>
          </div>
          <div className="bg-white rounded-xl border border-slate-200 p-4">
            <p className="text-xs font-semibold text-slate-500 uppercase">Unified Orders</p>
            <p className="text-2xl font-extrabold text-slate-900 mt-1">{status.metrics?.total_orders}</p>
            <p className="text-[11px] text-slate-500 mt-0.5">{status.metrics?.online_orders} Online + {status.metrics?.pos_orders} POS</p>
          </div>
          <div className="bg-white rounded-xl border border-slate-200 p-4">
            <p className="text-xs font-semibold text-slate-500 uppercase">Registered Customers</p>
            <p className="text-2xl font-extrabold text-slate-900 mt-1">{status.metrics?.total_customers}</p>
            <p className="text-[11px] text-emerald-600 font-semibold mt-0.5">Shared login everywhere</p>
          </div>
        </div>
      )}
    </>
  );
}
